import React from 'react';
import { useFileUploadPresenter } from './FileUpload.presenter';

import { AlertPopup } from '../AlertPopup/AlertPopup';
import { FileView } from './components/FileView/FileView';

import { ALERT_POPUP_TEXT } from '../../MainAnketa.constants';

import * as S from './FileUpload.styles';

export const FileUpload = ({
  title,
  doctypes,
  classification,
  currentPersonId,
  isContentHidden = false,
  gridArea,
  multiple = false,
  centered = false,
  disabled = false,
}) => {
  const presenter = useFileUploadPresenter({
    currentPersonId,
    classification,
    doctypes,
  });

  return (
    <S.Container gridArea={gridArea} data-test="fileUpload">
      <S.DragDropStyled
        title={title}
        ref={presenter.dragDropRef}
        process={presenter.uploadProcess}
        isContentHidden={isContentHidden}
        showFile={!isContentHidden && presenter.showFile}
        documentInfo={presenter.documentInfo}
        filesTotal={presenter.filesTotal}
        filesLeft={presenter.setLeftFiles}
        small={true}
        multiple={multiple}
        centered={centered}
        disabled={disabled}
        onChange={presenter.setFiles}
        deleteClick={() => !isContentHidden && presenter.handleDeleteClick({ type: 'type' })}
        dataTest={presenter.classification?.sysName}
      />

      {presenter.documentData && (
        <FileView
          documentData={presenter.documentData}
          documentTypes={presenter.doctypes}
          classify={presenter.classify}
          onChange={presenter.handleChangeType}
          onDelete={presenter.handleDeleteClick}
          onClose={() => {
            presenter.setDocumentData(null);
            presenter.setClassify(false);
          }}
        />
      )}

      {presenter.documentDataToDelete && (
        <AlertPopup
          title={ALERT_POPUP_TEXT.DOCUMENT_TO_DELETE.title}
          description={ALERT_POPUP_TEXT.DOCUMENT_TO_DELETE.description}
          agreeText={ALERT_POPUP_TEXT.DOCUMENT_TO_DELETE.agreeText}
          dataTest="removeDocModal"
          onAgree={presenter.agreeToDelete}
          onCancel={() => presenter.setDocumentDataToDelete(null)}
          onClose={() => presenter.setDocumentDataToDelete(null)}
        />
      )}
    </S.Container>
  );
};
